import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Skeleton } from './Skeleton'

export const MessageBubbleSkeleton: React.FC<{ isSent?: boolean }> = ({ isSent = false }) => {
  const theme = useTheme()
  const styles = getStyle(theme, isSent)

  if (isSent) {
    return (
      <View style={styles.sentContainer}>
        <View style={styles.sentWrapper}>
          <View style={styles.sentBubble}>
            <Skeleton width="100%" height={30} borderRadius={6} />
          </View>
        </View>
        <Skeleton width={100} height={15} borderRadius={8} style={styles.sentTimestamp} />
      </View>
    )
  }

  return (
    <View style={styles.receivedContainer}>
      <View style={styles.receivedWrapper}>
        <View style={styles.receivedBubble}>
          <Skeleton width="100%" height={30} borderRadius={8} />
        </View>
      </View>
      <View style={styles.messageFooter}>
        <Skeleton width={25} height={25} borderRadius={13} />
        <Skeleton width={100} height={15} borderRadius={8} style={styles.receivedTimestamp} />
      </View>
    </View>
  )
}

export const MessageBubbleSkeletonList: React.FC<{ count?: number }> = ({ count = 5 }) => {
  const theme = useTheme()
  return (
    <View style={{ paddingHorizontal: theme.spacing.lg, paddingVertical: theme.spacing.md }}>
      {Array.from({ length: count }).map((_, index) => (
        <MessageBubbleSkeleton key={index} isSent={index % 2 === 0} />
      ))}
    </View>
  )
}

const getStyle = (theme: Theme, isSent: boolean) =>
  StyleSheet.create({
    sentContainer: {
      alignItems: 'flex-end',
      marginBottom: theme.spacing.md,
    },
    sentWrapper: {
      width: '25%',
      alignItems: 'flex-end',
      marginBottom: theme.spacing.xs,
    },
    sentBubble: {
      width: '100%',
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.xs,
      borderRadius: 18,
      borderBottomRightRadius: 4,
      backgroundColor: theme.colors.grey,
    },
    sentTimestamp: {
      marginTop: theme.spacing.xs,
      alignSelf: 'flex-end',
    },
    receivedContainer: {
      marginBottom: theme.spacing.md,
    },
    receivedWrapper: {
      alignItems: 'flex-start',
    },
    receivedBubble: {
      width: '25%',
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.xs,
      borderRadius: 18,
      borderBottomLeftRadius: 4,
      backgroundColor: theme.colors.grey,
      borderWidth: 1,
      borderColor: theme.colors.grey,
    },
    messageFooter: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: theme.spacing.xs,
    },
    receivedTimestamp: {
      marginLeft: theme.spacing.sm,
    },
  })

